import { Box, IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const suppliersColumns = ( handleEdit, handleDelete, colors) => [
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "contact_info",
    headerName: "Información de Contacto",
    flex: 1,
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 0.4,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton onClick={() => handleEdit(params.row.id)} sx={{ color: colors.grey[100] }}>
          <EditOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleDelete(params.row.id)} sx={{ color: colors.grey[100] }}>
          <DeleteOutlinedIcon />
        </IconButton>
      </Box>
    ),
  },
];

export { suppliersColumns }